import { render, staticRenderFns } from "./NotificationListPopover.vue?vue&type=template&id=797eb0a8&scoped=true&"
import script from "./NotificationListPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationListPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationListPopover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationListPopover.vue?vue&type=style&index=1&id=797eb0a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797eb0a8",
  null
  
)

export default component.exports